import React, { useEffect, useState, useRef } from 'react';
//import axios from 'axios';
import '../styles/Settings.css'; // pour les styles du switch animé
import '../styles/styles.css';
//import '../styles/styles2.css';
import {  useLocation, useNavigate } from 'react-router-dom';
import Alert from './Alert';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n'; // chemin à adapter selon ton arborescence
import LanguageSelector from './LanguageSelector';
import api from '../services/api';



const SettingsLang = ({ socket, prompt}) => {
  
const { t } = useTranslation();
const location = useLocation();

const fromDiscussionId = location.state?.fromDiscussion;

  const token = localStorage.getItem('token');
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// détection RTL
const isRTL = document.documentElement.dir === 'rtl' || i18n.language === 'ar';




const [user, setUser] = useState(null);



useEffect(() => {
  const storedUser = localStorage.getItem('user');
  if (storedUser) {
    setUser(JSON.parse(storedUser));
  }
}, []);


useEffect(() => {
  const fetchMe = async () => {
    try {
      const res = await api.get('/api/users/me');
      setUser(res.data);
     // localStorage.setItem('user', JSON.stringify(res.data)); // cache optionnel
    } catch (err) {
      console.error(err);
    }
  };

  fetchMe();
}, []);




useEffect(() => {
  if (!socket) return;

  const handleStatus = (data) => {
    //console.log("📡 userStatusChanged :", data);
  };

  socket.on("userStatusChanged", handleStatus);
  return () => socket.off("userStatusChanged", handleStatus);
}, [socket]);


const navigate = useNavigate();



  return (

  <div className="settings-container">

<div className="groupe1" >
<div><h2>{t('settings.language')}</h2>
<div dangerouslySetInnerHTML={{
          __html: t('settings.language_explication')
        }}>
         

</div>
</div>

    <div className="setting-group" >
  <div className="setting-item setting-lang">
  <LanguageSelector />
  </div>
  </div>
</div>
  </div>


);

};

export default SettingsLang;
